import { SystemNotifications as BaseSystemNotifications } from '@fv/client-components'

import { useSystemNotifications } from './queries'

export const SystemNotifications = () => {
  const notificationsQuery = useSystemNotifications()
  return <BaseSystemNotifications notifications={notificationsQuery.data} />
}
